import user1 from "../../assets/images/user-1.jpg";
import user2 from "../../assets/images/user-2.jpg";
import user3 from "../../assets/images/user-3.jpg";
import user4 from "../../assets/images/user-4.jpg";
import user5 from "../../assets/images/user-5.jpg";
import user6 from "../../assets/images/user-6.jpg";

import energyImg from "../../assets/icons/energy.png";
import hygieneImg from "../../assets/icons/hygiene.png";

import agricImg from "../../assets/icons/agric.png";
import jobSme from "../../assets/images/sme.jpg";
import incubatorImg from "../../assets/images/incu-2.jpg";
import acceleratorImg from "../../assets/images/acc-1.jpg";
import OYE from "../../assets/images/hero-2.jpg";
import showcase3 from "../../assets/images/showcase-3.jpg";

import event1 from "../../assets/images/events/1.jpg";
import event2 from "../../assets/images/events/2.jpg";
import event3 from "../../assets/images/events/3.jpg";

import news1 from "../../assets/images/news/1.jpg";
import news2 from "../../assets/images/news/2.jpg";

import testimony1 from "../../assets/images/testimonials/1.jpeg";
import testimony2 from "../../assets/images/testimonials/2.jpeg";
import testimony3 from "../../assets/images/testimonials/3.jpeg";
import testimony4 from "../../assets/images/testimonials/4.jpeg";
import testimony5 from "../../assets/images/testimonials/5.jpeg";

import {
  FiShoppingCart,
  FiCreditCard,
  FiSettings,
  FiBriefcase,
  FiUser,
} from "react-icons/fi";

const navLInks = [
  {
    title: "About",
    path: null,
    dropdownLinks: [
      {
        path: "/green-and-circular",
        title: "Green and Circular Economy in Ghana",
        dropdownLinks: [],
      },
      {
        path: "/green-project",
        title: "The GrEEn Project",
        dropdownLinks: [],
      },
    ],
  },
  {
    title: "Green Employment",
    path: null,
    dropdownLinks: [
      {
        path: "/about-oye",
        title: "About OYE Approach",
        dropdownLinks: [],
      },
      {
        path: "/oye-graduates",
        title: "OYE Graduates",
        dropdownLinks: [],
      },
      {
        path: "/jobs",
        title: "Green Jobs",
        dropdownLinks: [],
      },
      {
        path: "/green-employers",
        title: "Green Employers",
        dropdownLinks: [],
      },

    ],
  },
  {
    title: "Green SMEs",
    path: null,
    dropdownLinks: [
      {
        path: "/incubation-and-acceleration?apply=incubation",
        title: "Incubator",
        dropdownLinks: [],
      },
      {
        path: "/incubation-and-acceleration?apply=acceleration",
        title: "Accelerator",
        dropdownLinks: [],
      },
      {
        path: "/mentors",
        title: "Mentors",
        dropdownLinks: [],
      },
      {
        path: "/investors",
        title: "Investors",
        dropdownLinks: [],
      },
      {
        path: "/green-business",
        title: "Green Businesses",
        dropdownLinks: [],
      },
      {
        path: "/mentoring",
        title: "Mentoring",
        dropdownLinks: [],
      },
    ],
  },
  {
    title: "Resources",
    path: null,
    dropdownLinks: [
      {
        path: "/resources?sub_category=studies_reports",
        title: "Studies and Reports",
        dropdownLinks: [],
      },
      {
        path: "/resources?sub_category=sectors_briefs",
        title: "Sector Briefs",
        dropdownLinks: [],
      },
      {
        path: "/resources?sub_category=blogs",
        title: "Blogs",
        dropdownLinks: [],
      },
      {
        path: "/resources?sub_category=case_studies",
        title: "Case Studies",
        dropdownLinks: [],
      },
      {
        path: "/resources?sub_category=webinars_infographics_videos",
        title: "Webinars, Infographics & Videos",
        dropdownLinks: [],
      },
      {
        path: "/resources?sub_category=other",
        title: "Other",
        dropdownLinks: [],
      },
    ],
  },
  {
    title: "Contact",
    path: "/contact-us",
    dropdownLinks: [],
  },
  {
    title: "FAQs",
    path: "/faq",
    dropdownLinks: [],
  },
  {
    title: "Register",
    path: null,
    dropdownLinks: [
      {
        path: "/auth",
        title: "Sign Up",
        dropdownLinks: [],
      },
      {
        path: "/auth/sign-in",
        title: "Log In",
        dropdownLinks: [],
      },
    ],
  },
];

export const footerNavLInks = [
  {
    title: "About",
    path: null,
    dropdownLinks: [
      {
        path: "/green-and-circular",
        title: "Green and Circular Economy in Ghana",
        dropdownLinks: [],
      },

      {
        path: "/green-project",
        title: "The GrEEn Project",
        dropdownLinks: [],
      },
    ],
  },
  {
    title: "Green Employment",
    path: null,
    dropdownLinks: [
      {
        path: "/about-oye",
        title: "About OYE Approach",
        dropdownLinks: [],
      },
      {
        path: "/oye-graduates",
        title: "OYE Graduates",
        dropdownLinks: [],
      },

      {
        path: "/jobs",
        title: "Green Jobs",
        dropdownLinks: [],
      },
      {
        path: "/green-employers",
        title: "Green Employers",
        dropdownLinks: [],
      },
      {
        path: "/mentoring",
        title: "Mentoring",
        dropdownLinks: [],
      },
    ],
  },
  {
    title: "Green SMEs",
    path: null,
    dropdownLinks: [
      {
        path: "/incubation-and-acceleration?apply=incubation",
        title: "Incubator",
        dropdownLinks: [],
      },
      {
        path: "/incubation-and-acceleration?apply=acceleration",
        title: "Accelerator",
        dropdownLinks: [],
      },
      {
        path: "/mentors",
        title: "Mentors",
        dropdownLinks: [],
      },
      {
        path: "/investors",
        title: "Investors",
        dropdownLinks: [],
      },
      {
        path: "/green-business",
        title: "Green Businesses",
        dropdownLinks: [],
      },
    ],
  },
  {
    title: "Other Links",
    path: null,
    dropdownLinks: [
      {
        path: "/events",
        title: "Events",
        dropdownLinks: [],
      },
      {
        path: "/news",
        title: "News",
        dropdownLinks: [],
      },
      {
        title: "Resources",
        path: "/resources?sub_category=other",
        dropdownLinks: [],
      },
      {
        title: "Contact",
        path: "/contact-us",
        dropdownLinks: [],
      },
      {
        title: "FAQs",
        path: "/faq",
        dropdownLinks: [],
      },
    ],
  },

  {
    title: "Register",
    path: null,
    dropdownLinks: [
      {
        path: "/auth",
        title: "Sign Up",
        dropdownLinks: [],
      },
      {
        path: "/auth/sign-in",
        title: "Log In",
        dropdownLinks: [],
      },
    ],
  },
];

const keyTargets = [
  {
    count: "10",
    target:
      "Metropolitan, Municipal and District Assemblies (MMDAs) have transitioned to Green and climate-resilient local economies.",
  },
  {
    count: "1500",
    target:
      "Decent and sustainable jobs created by MSMEs for youth, women and returning migrants (at least)",
  },
  {
    count: "3500",
    target:
      "Youth, women and returning migrants have developed self-employment opportunities (at least)",
  },
  {
    count: "70000",
    target:
      "Youth, women and returning migrants added to the Financial Inclusion ecosystem (at least)",
  },
];

const dashNavLInks = [
  {
    name: "Business",
    path: "business",
    subMenu: [],
    icon: FiShoppingCart,
  },
  {
    name: "Job",

    subMenu: [
      {
        name: "Applied Jobs",
        path: "jobs?type=applied",
        icon: "",
      },
      {
        name: "Posted Jobs",
        path: "jobs?type=posted",
        icon: "",
      },
      {
        name: "Suggested Jobs",
        path: "jobs?type=suggested",
        icon: "",
      },
    ],
    icon: FiBriefcase,
  },
  {
    name: "Applications",

    subMenu: [
      {
        name: "OYE",
        path: "application/oye-details",
        icon: "",
      },
      {
        name: "Incubation",
        path: "business?apply=incubation",
        icon: "",
      },
      {
        name: "Acceleration",
        path: "business?apply=acceleration",
        icon: "",
      },
      {
        name: "Mentorship Request",
        path: "support/mentorship",
        icon: "",
      },
      {
        name: "Investment Request",
        path: "support/investment",
        icon: "",
      },
    ],
    icon: FiCreditCard,
  },
  {
    name: "Profile",
    path: "me",
    icon: FiUser,
    subMenu: [],
  },
  // {
  //   name: "Account",
  //   path: "settings",
  //   icon: FiSettings,
  //   subMenu: [],
  // },
];

export const investorTypes = [
  "Impact investor",
  "Private Equity",
  "Venture Capital",
  "Angel Investor",
  "Foundation",
  "Commercial Bank",
  "Micro finance institution",
  "Crowdfunding",
  "Non-profit",
  "Individuals",
];

export const fundingTypes = [
  "0 – 5k (Euro)",
  "5k – 10k (Euro)",
  "10k – 20k (Euro)",
  "20k – 100k (Euro)",
  "Foundation",
  "100k – 300k (Euro)",
  "300k + (Euro)",
];

const mentorDashNavLInks = [
  {
    name: "Profile",
    path: "me",
    icon: FiUser,
    subMenu: [],
  },
  // {
  //   name: "Account",
  //   path: "settings",
  //   icon: FiSettings,
  //   subMenu: [],
  // },
];

const investorDashNavLInks = [
  {
    name: "Profile",
    path: "me",
    icon: FiUser,
    subMenu: [],
  },
  // {
  //   name: "Account",
  //   path: "settings",
  //   icon: FiSettings,
  //   subMenu: [],
  // },
];

const oyeGraduates = [
  {
    title: "Felix Appiah",
    position: "OYE Graduate",
    companyName: "",
    icon: user1,
  },
  {
    title: "Rachael Gyan",
    position: "OYE Graduate",
    companyName: "",
    icon: user2,
  },
  {
    title: "Abigail Amoako",
    position: "OYE Graduate",
    companyName: "",
    icon: user3,
  },
  // {
  //   title: "Rosaline Ahine",
  //   position: "OYE Graduate",
  //   companyName: "",
  //   icon: user4,
  // },
  {
    title: "Clementina Agana",
    position: "OYE Graduate",
    companyName: "",
    icon: user5,
  },
  {
    title: "Nana Adoma",
    position: "OYE Graduate",
    companyName: "",
    icon: user6,
  },
];

const jobs = [
  {
    title: "Sanitation Officer",
    companyName: "Zoomlion Company Ltd",
    location: "Takoradi",
    type: "Full-Time",
    category: "Sanitation",
    icon: hygieneImg,
  },
  {
    title: "Solar Installer",
    companyName: "Solar Company Ltd",
    location: "Kumasi",
    type: "Full-Time",
    category: "Energy",
    icon: energyImg,
  },
  {
    title: "Agricultural Advisor",
    companyName: "PFAG",
    location: "Takoradi",
    type: "Full-Time",
    category: "Agriculture",
    icon: agricImg,
  },
  {
    title: "Sanitation Officer",
    companyName: "Zoomlion Company Ltd",
    location: "Takoradi",
    type: "Full-Time",
    category: "Sanitation",
    icon: hygieneImg,
  },
  {
    title: "Solar Installer",
    companyName: "Solar Company Ltd",
    location: "Kumasi",
    type: "Full-Time",
    category: "Energy",
    icon: energyImg,
  },
  {
    title: "Agricultural Advisor",
    companyName: "PFAG",
    location: "Takoradi",
    type: "Full-Time",
    category: "Agriculture",
    icon: agricImg,
  },
  {
    title: "Sanitation Officer",
    companyName: "Zoomlion Company Ltd",
    location: "Takoradi",
    type: "Full-Time",
    category: "Sanitation",
    icon: hygieneImg,
  },
  {
    title: "Solar Installer",
    companyName: "Solar Company Ltd",
    location: "Kumasi",
    type: "Full-Time",
    category: "Energy",
    icon: energyImg,
  },
  {
    title: "Agricultural Advisor",
    companyName: "PFAG",
    location: "Takoradi",
    type: "Full-Time",
    category: "Agriculture",
    icon: agricImg,
  },
  {
    title: "Sanitation Officer",
    companyName: "Zoomlion Company Ltd",
    location: "Takoradi",
    type: "Full-Time",
    category: "Sanitation",
    icon: hygieneImg,
  },
  {
    title: "Solar Installer",
    companyName: "Solar Company Ltd",
    location: "Kumasi",
    type: "Full-Time",
    category: "Energy",
    icon: energyImg,
  },
  {
    title: "Agricultural Advisor",
    companyName: "PFAG",
    location: "Takoradi",
    type: "Full-Time",
    category: "Agriculture",
    icon: agricImg,
  },
];

const oyeCategories = [
  {
    title: "Job Seekers",
    description:
      "Youth and women interested in being employed are guided through a practical training and coached to acquire the needed skills through GrEEn’s OYE employability trajectory. The training is designed to facilitate their journey into the world of work. After the two-week long training ends, job seekers will be placed in an internship programme to acquire practical skills and hands-on experiences on-the-job.  During the internship programme, they engage with mentors and green business entrepreneurs to improve their employable skills.",
    image: jobSme,
    isReversed: false,
  },
  {
    title: "Entrepreneurs",
    description:
      "Youth and women at ideation or start-up stage of their green businesses are equipped with entrepreneurship skills through GrEEn’s OYE entrepreneurship trajectory. They are provided with support to build their business plans, identify customers and stakeholders and supported to kick-start their businesses",
    image: OYE,
    isReversed: true,
  },
  {
    title: "Business Plan Competition",
    description:
      "The Business Plan Competition opens once every year, starting July. Youth and women participating in GrEEn’s OYE programme with innovative but scalable ideas/products compete for a matching grant as well as technical backstopping to operationalise their innovative ideas/products.",
    image: showcase3,
    isReversed: false,
  },
  {
    title: "Mentoring/coaching",
    description:
      "Youth and women participating in GrEEn’s OYE programme are matched with seasoned mentors and coachers to provide timely technical advice and guidance during and after the training and internship. ",
    image: OYE,
    isReversed: true,
  },
];
const secondaryJobs = [
  {
    title: "OYE",
    description: `Under the Opportunities for Youth Employment (OYE),
      Green facilitates internships and job placements,
      hosting interactive and expert-led green job fairs and
      supporting start-ups through ideation and business
      plan competitions.`,
    image: jobSme,
    isReversed: true,
    path: "about-oye",
  },
  {
    title: "SMEs",
    description: `Green SMEs contribute to the protection of climate, the
      environment, and biodiversity through their products,
      services and business practices. Some SMEs focus on
      reducing the environmental footprint of their
      production process. Others focus on Green outputs and
      offer Green products and services.`,
    image: OYE,
    isReversed: false,
    path: "incubation-and-acceleration",
  },
  {
    title: "Incubator",
    description: `The GrEEn Incubation Programme supports businesses
    and start-ups who are at early stages of development
    (pre-revenue) to make better use of natural resources, be
    energy efficient, properly manage waste and pollution,
    among others, and operate profitable business ventures.`,
    image: incubatorImg,
    isReversed: true,
    path: "business?apply=incubation",
  },
  {
    title: "Accelerator",
    description: `The GrEEn Acceleration Programme will support more
      established SMEs (revenue stage) to develop investment
      readiness and operational excellence in order to scale up
      and grow. They will also be guided to adopt Green
      approach to their operations.`,
    image: acceleratorImg,
    isReversed: false,
    path: "business?apply=acceleration",
  },
];

const tertiaryJobs = [
  {
    title: "Mentors",
    description: `Under the GrEEn Mentoring Platform, experts, with a
      particular emphasis on successful women entrepreneurs,
      will be linked to recipients of the programmes. Mentors
      will provide specialised knowledge based on their field
      of expertise and strong networks.`,
  },
  {
    title: "Investors",
    description: `A Green investor is a person or organisation that
    provides financial support to increase the growth and
    success of start-ups and businesses in the circular
    economy.`,
  },
];

const events = [
  {
    image: event1,
    heading: "Event 1",
    body:
      "Lorem ipsum dolor sit ame consectetur adipiscing elit. Aenean tempor ornare ipsum, sit ametaliquam... ",
  },
  {
    image: event2,
    heading: "Event 2",
    body:
      "Lorem ipsum dolor sit ame consectetur adipiscing elit. Aenean tempor ornare ipsum, sit ametaliquam... ",
  },
  {
    image: event3,
    heading: "Event 3",
    body:
      "Lorem ipsum dolor sit ame consectetur adipiscing elit. Aenean tempor ornare ipsum, sit ametaliquam... ",
  },
  {
    image: event2,
    heading: "Event 1",
    body:
      "Lorem ipsum dolor sit ame consectetur adipiscing elit. Aenean tempor ornare ipsum, sit ametaliquam... ",
  },
  {
    image: event3,
    heading: "Event 2",
    body:
      "Lorem ipsum dolor sit ame consectetur adipiscing elit. Aenean tempor ornare ipsum, sit ametaliquam... ",
  },
  {
    image: event2,
    heading: "Event 3",
    body:
      "Lorem ipsum dolor sit ame consectetur adipiscing elit. Aenean tempor ornare ipsum, sit ametaliquam... ",
  },
  {
    image: event1,
    heading: "Event 2",
    body:
      "Lorem ipsum dolor sit ame consectetur adipiscing elit. Aenean tempor ornare ipsum, sit ametaliquam... ",
  },
  {
    image:
      "https://i2.wp.com/circumspecte.com/wp-content/uploads/2019/05/Gloria-Buckman-Event-Planners-Hub-Ghana.jpg?fit=761%2C600&ssl=1",
    heading: "Event 3",
    body:
      "Lorem ipsum dolor sit ame consectetur adipiscing elit. Aenean tempor ornare ipsum, sit ametaliquam... ",
  },
  {
    image:
      "https://i2.wp.com/circumspecte.com/wp-content/uploads/2019/05/Gloria-Buckman-Event-Planners-Hub-Ghana.jpg?fit=761%2C600&ssl=1",
    heading: "Event 3",
    body:
      "Lorem ipsum dolor sit ame consectetur adipiscing elit. Aenean tempor ornare ipsum, sit ametaliquam... ",
  },
];

const news = [
  {
    image: news1,
    heading: "Title Goes Here",
    body:
      "Lorem ipsum dolor sit ame consectetur adipiscing elit. Aenean tempor ornare ipsum, sit ametaliquam... ",
  },
  {
    image: news2,
    heading: "Title Goes Here",
    body:
      "Lorem ipsum dolor sit ame consectetur adipiscing elit. Aenean tempor ornare ipsum, sit ametaliquam... ",
  },
  {
    image:
      "https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F89760829%2F400224477667%2F1%2Foriginal.20200128-151915?w=800&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C177%2C2110%2C1055&s=eee3e1b92cbe98743a45e55b439c7712",
    heading: "Title Goes Here",
    body:
      "Lorem ipsum dolor sit ame consectetur adipiscing elit. Aenean tempor ornare ipsum, sit ametaliquam... ",
  },
  {
    image:
      "https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F89760829%2F400224477667%2F1%2Foriginal.20200128-151915?w=800&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C177%2C2110%2C1055&s=eee3e1b92cbe98743a45e55b439c7712",
    heading: "Title Goes Here",
    body:
      "Lorem ipsum dolor sit ame consectetur adipiscing elit. Aenean tempor ornare ipsum, sit ametaliquam... ",
  },
  {
    image:
      "https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F89760829%2F400224477667%2F1%2Foriginal.20200128-151915?w=800&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C177%2C2110%2C1055&s=eee3e1b92cbe98743a45e55b439c7712",
    heading: "Title Goes Here",
    body:
      "Lorem ipsum dolor sit ame consectetur adipiscing elit. Aenean tempor ornare ipsum, sit ametaliquam... ",
  },
  {
    image:
      "https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F89760829%2F400224477667%2F1%2Foriginal.20200128-151915?w=800&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C177%2C2110%2C1055&s=eee3e1b92cbe98743a45e55b439c7712",
    heading: "Title Goes Here",
    body:
      "Lorem ipsum dolor sit ame consectetur adipiscing elit. Aenean tempor ornare ipsum, sit ametaliquam... ",
  },
  {
    image:
      "https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F89760829%2F400224477667%2F1%2Foriginal.20200128-151915?w=800&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C177%2C2110%2C1055&s=eee3e1b92cbe98743a45e55b439c7712",
    heading: "Title Goes Here",
    body:
      "Lorem ipsum dolor sit ame consectetur adipiscing elit. Aenean tempor ornare ipsum, sit ametaliquam... ",
  },
  {
    image:
      "https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F89760829%2F400224477667%2F1%2Foriginal.20200128-151915?w=800&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C177%2C2110%2C1055&s=eee3e1b92cbe98743a45e55b439c7712",
    heading: "Title Goes Here",
    body:
      "Lorem ipsum dolor sit ame consectetur adipiscing elit. Aenean tempor ornare ipsum, sit ametaliquam... ",
  },
  {
    image:
      "https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F89760829%2F400224477667%2F1%2Foriginal.20200128-151915?w=800&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C177%2C2110%2C1055&s=eee3e1b92cbe98743a45e55b439c7712",
    heading: "Title Goes Here",
    body:
      "Lorem ipsum dolor sit ame consectetur adipiscing elit. Aenean tempor ornare ipsum, sit ametaliquam... ",
  },
];

export const citiesRegions = {
  Ahafo: ["Goaso", "Hwidiem", "Kenyasi", "Kukuom"],
  Ashanti: [
    "Abrepo Junction",
    "Abuakwa",
    "Adum",
    "Afrancho",
    "Agogo",
    "Agona",
    "Ahodwo",
    "Airport",
    "Akumadan",
    "Amakom",
    "Aputuogya",
    "Asafo",
    "Ash-Town",
    "Asokore Mampong",
    "Asokwa",
    "Asuofia",
    "Atonsu",
    "Ayeduasi",
    "Ayigya",
    "Bantama",
    "Barekese",
    "Bekwai",
    "Boadi",
    "Bomso",
    "Breman",
    "Brewery",
    "Buoho",
    "Buokrom Estate",
    "Daban",
    "Dakwadwom",
    "Deduako",
    "Denyame",
    "Effiduase",
    "Ejisu",
    "Ejura",
    "Emina",
    "Esreso",
    "Fawode",
    "Gyinyasi",
    "Jachie Pramso",
    "Kaasi",
    "KNUST",
    "Kodie",
    "Komfo Anokye",
    "Konongo",
    "Kotei",
    "Krofrom",
    "Kumasi",
    "Maakro",
    "Mampong",
    "Mankranso",
    "Manso Nkwanta",
    "Nkawie",
    "North Suntreso",
    "Nyinahin",
    "Obuasi",
    "Oforikrom",
    "Pankrono",
    "Santasi",
    "Sokoban",
    "South Suntreso",
    "Suame",
    "Tafo",
    "Takwa-Maakro",
    "Tanoso",
    "Tepa",
    "TUC",
  ],
  Bono: [
    "Banda Ahenkro",
    "Brekum",
    "Dormaa Ahenkro",
    "New Drobo",
    "Nsawkaw",
    "Sampa",
    "Sunyani",
  ],
  "Bono East": [
    "Atebubu",
    "Buipe",
    "Jema",
    "Kintampo",
    "Kwame Danso",
    "Nkoranza",
    "Prang",
    "Techiman",
    "Wenchi",
    "Yeji",
  ],
  Central: [
    "Agona Swedru",
    "Amanfrom",
    "Anomabu",
    "Apam",
    "Bawjiase",
    "Breman Asikuma",
    "Budumburam",
    "Cape Coast",
    "Domeabra",
    "Elmina",
    "Foso",
    "Kasoa Ofaakor",
    "Kasoa Zongo",
    "Liberia Camp",
    "Mankessim",
    "Millennium City",
    "Mumford",
    "Nyakrom",
    "Nyananor",
    "Nyanyano",
    "Oduponkpehe",
    "Opeikuma",
    "Pentecost Seminary",
    "Saltpond",
    "Winneba",
  ],
  Eastern: [
    "Abetifi",
    "Abompe",
    "Aburi",
    "Adeiso",
    "Adjeiikrom",
    "Adukrom",
    "Ahwerease",
    "Akim Oda",
    "Akim Swedru",
    "Akosombo",
    "Akropong",
    "Akwatia",
    "Akyem Hemang",
    "Amanokrom",
    "Apirede",
    "Asamankese",
    "Asesewa",
    "Atimpoku",
    "Ayiensu",
    "Begoro",
    "Bepoase",
    "Bisibom",
    "Bososo",
    "Brekusu",
    "Coaltar",
    "Dawu",
    "Dedesoworako",
    "Donkorkrom",
    "Dwenase",
    "Gyankama",
    "Juaso",
    "Kade",
    "Kibi",
    "Kitase",
    "Koforidua",
    "Kwabeng",
    "Mamfe",
    "Mampong",
    "Mpraeso",
    "New Abirem",
    "Nkawkaw",
    "Nsawam",
    "Nsutam",
    "Obooho",
    "Obosomase",
    "Odumase Krobo",
    "Ofoase",
    "Osino",
    "Peduase",
    "Saaman",
    "Somanya",
    "Summer",
    "Suhum",
    "Tease",
    "Tutu",
  ],
  "Greater Accra": [
    "Abelemkpe",
    "Ablekuma",
    "Abokobi",
    "Abossey Okai",
    "Accra Newtown",
    "Achimota",
    "Adabraka",
    "Adenta",
    "Afienya",
    "Agbogba",
    "Airport",
    "Amasaman",
    "Ashiaman",
    "Ashongman",
    "Aslyum Down",
    "Baatsona - Spintex",
    "Bortianor",
    "Cantonment",
    "Dansoman",
    "Darkuman",
    "Dawhenya",
    "Dodowa",
    "Dome",
    "Dzorwulu",
    "East Legon",
    "Gbawe",
    "Haatso",
    "James Town",
    "Kanda",
    "Kaneshie",
    "Kasoa",
    "Kissieman",
    "Kokrobite",
    "Korle Bu",
    "Kpone",
    "Kwabenya",
    "Kwashieman",
    "Labadi",
    "Labone",
    "Lapaz",
    "Lartebiokorshie",
    "Lashibi",
    "Legon",
    "Madina",
    "Makola",
    "Mallam",
    "McCarthy Hill",
    "Michel Camp",
    "Nima",
    "Nungua",
    "Oblogo Mallam",
    "Odoponkpehe",
    "Odorkor",
    "Osu",
    "Oyarifa",
    "Patang",
    "Prampram",
    "Ridge",
    "Roman Ridge",
    "Sakumono",
    "Santa Maria",
    "Sowutuom",
    "Taifa",
    "Tema",
    "Tema New Town",
    "Tesano",
    "Teshie",
    "Tetegu",
    "Tieman",
    "Tudu",
    "Weija",
    "Westhills",
  ],
  "Nort East": ["Chereponi", "Gambaga", "Nalerigu", "Walewale"],
  Nothern: ["Bimbila", "Gushiegu", "Kpandae", "Salaga", "Tamale", "Yendi"],
  Oti: ["Chinderi", "Jasikan", "Kadjebi", "Kete Krachi", "Kpassa", "Nkonya"],
  Savannah: ["Bole", "Buipe", "Damango", "Salaga", "Sawla", "Tolon"],
  "Upper East": ["Bawku", "Bolgatanga", "Bongo", "Navrongo", "Paga", "Tongo"],
  "Upper West": [
    "Funsi",
    "Gwollu",
    "Issa",
    "Jirapa",
    "Kaleo",
    "Lambussie",
    "Lawra",
    "Nadowli",
    "Nandom",
    "Tumu",
    "Wa",
    "Wechiau",
  ],
  Volta: [
    "Adaklu Waya",
    "Adidome",
    "Aflao",
    "Akatsi",
    "Ave Dakpa",
    "Ho.",
    "Hohoe",
    "Keta",
    "Kpando",
    "Kpetoe",
    "Kpeve",
    "Sogakope",
  ],
  Western: [
    "Abase",
    "Aboso",
    "Adiawoso",
    "Adiembra",
    "Adwowa",
    "Agona Nkwanta",
    "Agufo",
    "Ahonozo",
    "Akatachi",
    "Alabokazo",
    "Anaji",
    "Apowa",
    "Apremodo",
    "Asankragua",
    "Awukyere",
    "Axim",
    "Beahu",
    "Bogoso",
    "Busua",
    "Daboase",
    "Dadwen",
    "Diabene",
    "Dixcove",
    "East Tanokrom",
    "Effiakuma",
    "Eikwe",
    "Elubo",
    "Essiama",
    "Essikado",
    "Essipong",
    "Ewusiejo",
    "Fijai",
    "Funko",
    "Half Assini",
    "Hotopo",
    "Inchaban",
    "kansaworado",
    "Kejabil",
    "Kojokrom",
    "Kwawkrom",
    "Kweikuma",
    "kwesimintsim",
    "Manso",
    "Miemia",
    "Mpintsin",
    "New Akwidaa",
    "New Amanfu",
    "New Takoradi",
    "Ngyiresia",
    "Nkroful",
    "Nsein",
    "Ntankoful",
    "Nzulezo",
    "Old Akwidaa",
    "Prestea",
    "Princess Town",
    "Samreboi",
    "Sekondi",
    "Shama",
    "Takoradi",
    "Tarkwa",
    "Tikobo No.1",
    "Tikobo No.2",
    "West Tanokrom",
    "Windy Ridge",
  ],
  "Western North": [
    "Attankona",
    "Nkatieso",
    "Abochia",
    "Abusam-kwawu",
    "Achimfo",
    "Acquai Allah",
    "Adabokrom",
    "Adamase",
    "Adiembra",
    "Adjakaa",
    "Adjoafua",
    "Adukrom",
    "Afere",
    "Aferewa",
    "Agya Mensahkrom",
    "Ahibenso",
    "Akaaso",
    "Akaatiso",
    "Akontombra",
    "Akronsu",
    "Amadukrom",
    "Amoaya",
    "Amonie",
    "Anhwiafutu",
    "Anhwiaso",
    "Ankra-Muano",
    "Antobia",
    "Apronsee Mission",
    "Asawinso",
    "Asemkrom",
    "Asikrom (Ensonnyameye)",
    "Asuontaa",
    "Asuopiri",
    "Awaso",
    "Ayidam",
    "Benchema",
    "Benomsuo",
    "Bethlehem",
    "Bibiani",
    "Bibiani",
    "Bodi",
    "Boison",
    "Boizan",
    "Bokabo",
    "Bonsu Nkwanta",
    "Car Owner",
    "Chirano",
    "Dadieso",
    "Denchemuosue",
    "Disueano",
    "Dominibo",
    "Elluokrom",
    "Enchi",
    "Enchi",
    "Essam Debiso",
    "Goka",
    "Gyema",
    "Hene Nkwanta",
    "Homgyebre",
    "Hwenampori",
    "Jensue",
    "Juabeso Nkwanta",
    "Juabeso",
    "Juaboso",
    "kaase",
    "Kakanabo",
    "Kama",
    "Kankyiabo",
    "Kantakrobo",
    "Kefass",
    "Kofi Krah",
    "Kofikrom",
    "Kojoaba",
    "Kojofosukrom",
    "Kotosaa",
    "Kramokrom",
    "Kunkumso",
    "Kwafukaa",
    "Kwaku Kyerekrom",
    "Kwame Adjei Krom",
    "Kwamebikrom",
    "Kwawu",
    "Kwesikrom",
    "Kyerkyewere",
    "Mafia",
    "Mangoase-Punpunso",
    "Mangoase",
    "Mayera",
    "Moshiehene Krom",
    "New Abesim",
    "New Achiase",
    "New Nsuatre",
    "New Yakasi",
    "Nkrabea",
    "Nkwanta",
    "Nso Nyame Ye (Mireku)",
    "Nsowakrom",
    "Ntesano",
    "Nyamebekyere No.1",
    "Nyankamam",
    "Okrayawkrom",
    "Old Debiso",
    "Old Yakasi",
    "Omanpe",
    "Oseikojokrom",
    "Osumanikrom",
    "Owusu Krom",
    "Patakro",
    "Pramprase",
    "Proso",
    "Sayerano",
    "Sefwi Anhwiaso",
    "Sefwi Bekwai",
    "Sewum",
    "Sonka No.1",
    "Subri Nkwanta (Kojina)",
    "Subri",
    "Suiano",
    "Surano",
    "Tanoso-Praso",
    "Wenchi",
    "Yawmatwa",
    "Yiwabra",
  ],
};

export const testimonials = [
  {
    name: "Rachael Gyan",
    support:
      "GrEEn Opportunities for Youth Employment (OYE) Employability Training and Intern",
    location: "Western region",
    quote:
      "This is a two-month internship programme and I have only been here for a month but within that period, I have learnt a lot of sustainable farming practices and no longer have any interest in nursing, I want to focus solely on sustainable farming and want to thank the GrEEn Project and TrustEco for making it possible for me to learn and work in the sustainable agriculture sector.",
    image: testimony1,
  },
  {
    name: "Felix Appiah",
    support:
      "GrEEn Opportunities for Youth Employment (OYE) Employability Training and Intern",
    location: "Western region",
    quote:
      "I have come to understand the whole OYE programme as training and knowledge-acquiring so basically, it’s not about you doing something to get money but you doing something to build knowledge and skills.",
    image: testimony2,
  },
  {
    name: "Clementina Agana",
    support: "OYE Employability Training and Intern",
    location: "Ashanti region",
    quote:
      "OYE is a big programme and gives you the opportunity to grow your skills and get support for your business ideas. For people looking for employment like me, it has prepared me for the job market and made it possible for me to get a full-time contract, which means I can support my single mother and also take care of myself.",
    image: testimony3,
  },
  {
    name: "Abigail Amoako",
    support: "OYE Employability Training and Intern",
    location: "Western region",
    quote:
      "I found out about the OYE training on the internet and registered for it. I was called and went to MDF office in Takoradi. I was interested in WASH because I used to have a water business that collapsed. During the OYE training, I was educated on how I can set up my business and make it successful.",
    image: testimony5,
  },
  {
    name: "Rosaline Ahine",
    support: "Winner, GrEEn COVID19 Innovation Challenge",
    location: "Western region",
    quote:
      "GrEEn helped me to do the approval for all my three products, nose masks, hand sanitiser, and liquid soaps with the Food and Drugs Authority. They gave me money for the payment of the certification and they also got me in touch with people at the Ghana Standards Authority. Now I have a factory where I produce the sanitisers and nose masks and supply to pharmacies and businesses in the region.",
    image: testimony4,
  },
];

export {
  navLInks,
  jobs,
  secondaryJobs,
  tertiaryJobs,
  events,
  news,
  oyeGraduates,
  oyeCategories,
  dashNavLInks,
  keyTargets,
  investorDashNavLInks,
  mentorDashNavLInks,
};
